/* [PATCH izdaja-prodajni-dok-ui v3] Izbira iz šifranta za masko dokumenta: maska skoči v /sifranti?tab=…&izbira=…&nazaj=…&vrstica=…,
   klik na vrstico shrani izbiro v sessionStorage in se vrne na »nazaj«; maska ob nalaganju izbiro prevzame. */
export type IzbiraVrsta = 'partner' | 'artikel' | 'sm';
const KEY = 'aicount_sifrant_izbira';
const TAB: Record<IzbiraVrsta, string> = { partner: 'partnerji', artikel: 'artikli', sm: 'sm' };

export function vSifrantPot(vrsta: IzbiraVrsta, nazaj: string, vrstica = -1): string {
  return `/sifranti?tab=${TAB[vrsta]}&izbira=${vrsta}&nazaj=${encodeURIComponent(nazaj)}${vrstica >= 0 ? `&vrstica=${vrstica}` : ''}`;
}
/** V Šifrantih: ali smo v načinu izbire za dano vrsto (bere URL). */
export function izbiraNacin(vrsta: IzbiraVrsta): URLSearchParams | null {
  const sp = new URLSearchParams(window.location.search);
  return sp.get('izbira') === vrsta ? sp : null;
}
/** V Šifrantih: shrani izbiro in se vrni v masko (polna navigacija — maska se naloži s strežnika). */
export function izbiraVrni(sp: URLSearchParams, vrsta: IzbiraVrsta, obj: any) {
  try { sessionStorage.setItem(KEY, JSON.stringify({ vrsta, vrstica: sp.get('vrstica'), obj })); } catch {}
  window.location.assign(sp.get('nazaj') || '/');
}
export function izbiraPrekini(sp: URLSearchParams) { window.location.assign(sp.get('nazaj') || '/'); }
/** V maski: prevzame in izbriše shranjeno izbiro. */
export function prevzemiIzbiro(): { vrsta: IzbiraVrsta; vrstica: string | null; obj: any } | null {
  try { const s = sessionStorage.getItem(KEY); if (!s) return null; setTimeout(() => { try { sessionStorage.removeItem(KEY); } catch {} }, 4000); return JSON.parse(s); } catch { return null; } // [PATCH izdaja-prodajni-dok-ui v4] izbris z zamikom (dvojni mount v dev)
}
